import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlert,
  showAlertLoading,
  showConfirmAlert,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { EscalaFormModal } from '../../../components/EscalaFormModal'
import { ErrosVinculos } from '../../../components/ErrosVinculos'
import { EscalaList } from '../../../core/_models'
import { deleteEscalaPessoa, getEscalaById } from '../../../core/_requests'
import { extrairErrosValidacao } from '../../../core/escalaHelpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  escala: EscalaList
}

export const MinhaEscalaActionsCell: FC<Props> = ({ escala }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = `escala iniciada em ${escala.dataInicioFormatada ?? escala.dataInicio}`

  /**
   * "Editar a escala inteira" não é um `PUT`: o backend não expõe
   * `PUT /escalas/{id}`, só `PUT /escalas/agenda` (um dia). O fluxo é
   * **excluir + recriar**, com o formulário pré-preenchido e uma confirmação que
   * diz exatamente o que vai acontecer — nada de botão "Salvar" fingindo um
   * endpoint que não existe.
   */
  const abrirSubstituicao = async () => {
    try {
      showAlertLoading()
      const detalhe = await getEscalaById(escala.id)
      Swal.close()
      showModal({
        title: 'Substituir escala',
        size: ModalSize.Large,
        content: <EscalaFormModal eixo='pessoal' escalaOriginal={detalhe} onSuccess={refetch} />,
      })
    } catch (error) {
      Swal.close()
      const erros = extrairErrosValidacao(error)
      showModal({
        title: 'Não foi possível abrir a escala',
        size: ModalSize.Medium,
        content: (
          <ErrosVinculos
            titulo='A API recusou a consulta:'
            itens={erros.todas.length ? erros.todas : [erros.mensagem ?? 'Erro inesperado.']}
          />
        ),
      })
    }
  }

  const excluir = async () => {
    const confirmado = await showConfirmAlert({
      title: 'Excluir a escala?',
      text: 'Todos os dias gerados a partir dela serão removidos.',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmado) return

    try {
      showAlertLoading()
      await deleteEscalaPessoa(escala.id)
      Swal.close()
      showToast({ variant: 'success', title: 'Escala removida.' })
      refetch()
    } catch (error) {
      const erros = extrairErrosValidacao(error)
      showAlert({
        title: 'Não foi possível excluir',
        text: erros.todas[0] ?? erros.mensagem ?? 'Erro inesperado.',
        icon: 'error',
      })
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{
        label: 'Substituir (excluir e recriar)',
        onClick: abrirSubstituicao,
        icon: IconPaths.Pen,
      }}
      items={[{ label: 'Excluir', onClick: excluir, danger: true }]}
    />
  )
}
